import { render, staticRenderFns } from "./order-item-reservations.vue?vue&type=template&id=2fef28f4&"
import script from "./order-item-reservations.vue?vue&type=script&lang=js&"
export * from "./order-item-reservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports